import React, { useEffect, useState } from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';
import { RxCrossCircled } from 'react-icons/rx';
import { fetchWrapper } from '../../_helpers';
import { useNavigate } from 'react-router-dom';

export { EmailVerify };

function EmailVerify() {
    // Defaults
    const navigate = useNavigate();
    const baseUrl = `${process.env.REACT_APP_API_URL}`;
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get('userId');
    const token = urlParams.get('token');

    // STATE
    const [emailVerified, setEmailVerified] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        verifyEmail();
    }, []);

    const verifyEmail = async () => {
        setEmailError(false);
        setEmailVerified(false);
        setIsLoading(true);

        if (userId) {
            try {
                await fetchWrapper.post(`${baseUrl}/auth/verify-email`, {
                    userId: userId,
                    token: token,
                });

                setEmailVerified(true);
                setIsLoading(false);

                setTimeout(() => {
                    navigate('/login');
                }, [2500]);
            } catch (error) {
                setEmailError(true);
                setIsLoading(false);
            }
        } else {
            setIsLoading(false);
            navigate('/login');
        }
    };

    return (
        <div>
            {emailVerified ? (
                <div className='d-flex justify-content-center align-items-center gap-2'>
                    <h4 className='m-0 p-0'>Email verified!</h4>
                    <FaRegCheckCircle size={25} />
                </div>
            ) : null}

            {isLoading ? (
                <>
                    <h4 className='text-center'>Verifying email...</h4>
                    <div className='d-flex justify-content-center mt-3'>
                        <span
                            style={{ width: '50px', height: '50px' }}
                            className='spinner-border spinner-border-sm'
                        ></span>
                    </div>
                </>
            ) : null}

            {emailError ? (
                <div className='d-flex justify-content-center align-items-center gap-2'>
                    <h4 className='m-0 p-0' style={{ color: 'red' }}>
                        Email was not verified!
                    </h4>
                    <RxCrossCircled size={25} color='red' />
                </div>
            ) : null}
        </div>
    );
}
